import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import InviteLeadsForm from './components/InviteLeadsForm';

import './InviteLeadsFromPreviousDeals.styles.scss';

type InviteLeadsFromPreviousDealsProps = {
  className?: string;
} & ModalProps;

const InviteLeadsFromPreviousDeals: React.ForwardRefRenderFunction<
  ModalRef,
  InviteLeadsFromPreviousDealsProps
> = (props, ref) => {
  const { className, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('invite-leads-from-previous-deals', className);

  const { t } = useTranslation();

  const onClose = useCallback(() => modal?.close(), [modal]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('inviteLeadsFromDeals')}
      {...rest}
    >
      <InviteLeadsForm onClose={onClose} />
    </Modal>
  );
};

export default forwardRef(InviteLeadsFromPreviousDeals);
